<template>
    <div :class="navbar">
        <slot></slot>
    </div>
</template>

<script>
import Toast from './Common/Toast';
import { NCH_ENV } from '../../../js/nch-env';

export default {
    name: 'AppWrapper',

    props: {
        clientSettings: String,
        settings: String,
        breadcrumb: String | Boolean,
        user: Object,
    },

    computed: {
        headerType() {
            return this.$store.getters.NAVBAR_FIXED;
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        navbar() {
            if (this.headerType && !this.breadcrumb) {
                return 'nch--navbar__fixed-nb';
            }
            if (this.headerType) {
                return 'nch--navbar__fixed';
            } return '';
        },
    },

    mounted() {
        // pega o token salvo no local storage
        const nochalksToken = localStorage.getItem('nochalks_token');

        // caso o token exista começamos aqui
        if (nochalksToken && this.user && this.user.id) {
            window.Echo.auth = {
                headers: {
                    Authorization: `Bearer ${nochalksToken}`,
                },
            };

            window.Echo
                .private(`${NCH_ENV.APP_HOST}.user.${this.user.id}`)
                .listen('WebsiteNotificationEvent', (e) => {
                    const content = {
                        component: Toast,
                        props: {
                            data: e.data,
                            language: this.language,
                        },
                    };
                    this.$toast(content, {
                        position: 'bottom-left',
                        timeout: 5000,
                        closeOnClick: false,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: false,
                        hideCloseButton: false,
                        hideProgressBar: false,
                        icon: false,
                    });
                },
                );
        }
    },

    created() {
        this.$createSettings(JSON.parse(this.clientSettings), JSON.parse(this.settings));
    },
};
</script>

<style scoped>
.nch--navbar__fixed {
    margin-top: 132px;
}
.nch--navbar__fixed-nb {
    margin-top: 95px;
}
</style>
